import React, { useEffect, useState } from "react";
import Footer2 from "../Components/Footer2";
import Navbar2 from "../Components/Navbar2";
import img from "../Assets/hiring.png";
// import img2 from "../Assets/Classroom-rafiki 4.png";
import { useParams } from "react-router-dom";
import { getSingleService, getCorporateHiring } from "../Common/apis";
import Loader from "../Loader/Loader";
import Aos from "aos";

function CorporateHiring() {
  useEffect(() => {
    Aos.init({
      duration: 1000, // animation duration in ms
      once: true // animate only once
    });
  }, []);
  // const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchService = async () => {
      try {
        setLoading(true);
        const res = await getCorporateHiring();
        setData(res.data);
      } catch (err) {
        console.error("Error fetching service:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchService();
  }, []);

  return (
    <div className="new-home">
      <Navbar2 />
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="grid md:grid-cols-2 grid-cols-1 md:gap-[182px] gap-[10px] md:px-[80px] px-[28px] md:pt-[74px] pt-[30px]">
            <div>
              <img
                data-aos="flip-up"
                src="/assets/services/logo2.svg"
                alt="vector"
                className="md:mb-[60px] mb-[40px]"
              />
              <div className="h-box">
                {/* <h6 dangerouslySetInnerHTML={{ __html: service.shortdescription }} className="font-sans font-[500] md:text-[31px] text-[20px] md:leading-[42px] leading-[32px] text-[#6953A3] md:pt-[74px] pt-[50px] md:max-w-[365px] max-w-[264px] w-full mx-auto text-center md:pb-[30px] pb-[20px]" />
                <p dangerouslySetInnerHTML={{ __html: service.description }} className="font-sans font-[400] md:text-[16px] text-[11px] md:leading-[26px] leading-[22px] text-center text-[#6953A3] md:max-w-[316px] max-w-[223px] w-full mx-auto" /> */}
                <h6 className="font-sans font-[500] md:text-[31px] text-[20px] md:leading-[42px] leading-[32px] text-[#6953A3] md:pt-[74px] pt-[50px] md:max-w-[365px] max-w-[264px] w-full mx-auto text-center md:pb-[30px] pb-[20px]">
                  Best Workforce Upskilling Program offered by Gisul
                </h6>
                <p className="font-sans font-[400] md:text-[16px] text-[11px] md:leading-[26px] leading-[22px] text-center text-[#6953A3] md:max-w-[316px] max-w-[223px] w-full mx-auto">
                  edForce a Leading Workforce Upskilling Accelerator has been
                  helping organizations of all stratus with seamless training
                  Modules. The lateral training program is an exercise that
                  design
                </p>
              </div>
            </div>
            <div>
              <img
                data-aos="flip-right"
                className="md:mt-[-70px] md:block hidden md:ml-[132px]"
                src="/assets/home/vector7.svg"
                alt=""
              />
              <div className="relative md:top-[-120px] ">
                <div className="flex flex-col gap-[14px]">
                  {data && data.length>0 && data.map((item, index) =>
                    index % 2 === 0 ? (
                      <div className="corp-box-l" key={`right-${index}`}>
                        <p className="font-[500] font-sans md:text-[20px] text-[14px] leading-[26px] text-[#263238] tracking-[-0.5px] absolute right-[20px] md:bottom-[28px] bottom-[16px]">
                          {item?.title}
                        </p>
                      </div>
                    ) : null
                  )}
                </div>
                <div className="flex flex-col gap-[14px] absolute md:top-[90px] top-[64px] md:left-[167px] left-[118px]">
                  {data && data.length>0 && data.map((item, index) =>
                    index % 2 !== 0 ? (
                      <div className="corp-box-r" key={`right-${index}`}>
                        <p className="font-[500] font-sans md:text-[20px] text-[14px] leading-[26px] text-[#263238] tracking-[-0.5px] absolute left-[78px] md:bottom-[28px] bottom-[16px]">
                          {item?.title}
                        </p>
                      </div>
                    ) : null
                  )}
                </div>

                {/* <div className="flex flex-col gap-[14px]">
                  <div className="corp-box-l">
                    <p className="font-[500] font-sans md:text-[20px] text-[14px] leading-[26px] text-[#263238] tracking-[-0.5px] absolute right-[20px] md:bottom-[28px] bottom-[16px]">
                      Large Course Portfolio
                    </p>
                  </div>
                  <div className="corp-box-l">
                    <p className="font-[500] font-sans md:text-[20px] text-[14px] leading-[26px] text-[#263238] tracking-[-0.5px] absolute right-[20px] md:bottom-[28px] bottom-[16px]">
                      Large Course Portfolio
                    </p>
                  </div>
                </div>
                <div className="flex flex-col gap-[14px] absolute md:top-[90px] top-[64px] md:left-[167px] left-[118px]">
                  <div className="corp-box-r">
                    <p className="font-[500] font-sans md:text-[20px] text-[14px] leading-[26px] text-[#263238] tracking-[-0.5px] absolute left-[78px] md:bottom-[28px] bottom-[16px]">
                      Cloud Labs
                    </p>
                  </div>
                  <div className="corp-box-r">
                    <p className="font-[500] font-sans md:text-[20px] text-[14px] leading-[26px] text-[#263238] tracking-[-0.5px] absolute left-[78px] md:bottom-[28px] bottom-[16px]">
                      Cloud Labs
                    </p>
                  </div>
                </div> */}
              </div>
            </div>
            <img
              data-aos="flip-right"
              className="mt-[70px] block md:hidden"
              src="/assets/home/vector7.svg"
              alt=""
            />
          </div>
          {/* <div className="hiring">
            <div className="hiring-left">
              <img src={img} />
              <br />
              <div className="hiring-box">
            
                <div
                  className="short-desc"
                  dangerouslySetInnerHTML={{ __html: service.shortdescription }}
                />
                <br />
                <div
                  className="rich-content"
                  dangerouslySetInnerHTML={{ __html: service.description }}
                />
              </div>
            </div>
            <div className="hiring-right">
              <img
                src={service.image}
                alt={service.title}
                width="500px"
                height="500px"
                style={{ objectFit: "cover" }}
              />
              <br />
              <br />
              
            </div>
          </div> */}
        </>
      )}
      <Footer2 />
    </div>
  );
}

export default CorporateHiring;
